import React, { useCallback } from 'react';
import EDListItem, {
  EDListItemButton,
} from '../../../../../../../../../BaseComponents/List/Components/EDListItem';
import EDListItemText from '../../../../../../../../../BaseComponents/List/Components/EDListItemText';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EkonomiskAnalysSideMenuIconButton from '../IconButton/EkonomiskAnalysSideMenuIconButton';
import EDKeybind from '../../../../../../../../../BaseComponents/Keybinds/EDKeybind';

interface IProps {
  sideMenuIsOpen: boolean;
  updateReport: () => void;
  haveSelectedAnalys: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      listItem: {
        paddingTop: 0,
        paddingBottom: 1,
        outline: 0,
      },
      listItemSideMenuOpen: {
        paddingTop: 10,
        paddingBottom: 11,
        paddingLeft: 24,
        marginBottom: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
      iconSideMenuOpen: {
        marginLeft: theme.spacing(-0.5),
      },
    } as const)
);

/**
 * Komponent för att öppna en dialog där en ny analys kan skapas
 */
const EkonomiskAnalysAnalyseraListItem: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = ({
  sideMenuIsOpen,
  updateReport,
  haveSelectedAnalys,
  disabled,
  disabledReason,
}) => {
  const { classes, cx } = useStyles();

  const doUpdateReport = useCallback(() => {
    if (haveSelectedAnalys) {
      updateReport();
    }
  }, [haveSelectedAnalys, updateReport]);

  return sideMenuIsOpen ? (
    <EDListItemButton
      key={'analysera'}
      onClick={updateReport}
      className={cx(classes.listItem, {
        [classes.listItemSideMenuOpen]: sideMenuIsOpen,
      })}
      disabled={!haveSelectedAnalys || disabled}
    >
      <EDKeybind blurOnHit keymap="a" alt global onKeyDown={doUpdateReport}>
        <EkonomiskAnalysSideMenuIconButton
          sideMenuOpen={sideMenuIsOpen}
          tooltipText="Uppdatera analysen enl. gjorda inställningar"
          iconType={'refresh'}
          color={disabled ? 'disabled' : 'primary'}
          onClick={updateReport}
          disabled={!haveSelectedAnalys || disabled}
          disabledReason={
            disabled && disabledReason ? disabledReason : undefined
          }
        />
        <EDListItemText
          primary={<strong>Analysera</strong>}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </EDKeybind>
    </EDListItemButton>
  ) : (
    <EDListItem
      key={'analysera'}
      className={cx(classes.listItem)}
      disabled={!haveSelectedAnalys || disabled}
    >
      <EDKeybind blurOnHit keymap="a" alt global onKeyDown={doUpdateReport}>
        <EkonomiskAnalysSideMenuIconButton
          sideMenuOpen={sideMenuIsOpen}
          tooltipText="Uppdatera analysen enl. gjorda inställningar"
          iconType={'refresh'}
          color={disabled ? 'disabled' : 'primary'}
          onClick={updateReport}
          disabled={!haveSelectedAnalys || disabled}
          disabledReason={
            disabled && disabledReason ? disabledReason : undefined
          }
        />
        <EDListItemText
          primary={<strong>Analysera</strong>}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </EDKeybind>
    </EDListItem>
  );
};

export default EkonomiskAnalysAnalyseraListItem;
